'use client'

import { SessionProvider } from 'next-auth/react'

export function HomeProviders({ children }: { children: React.ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>
}
